const navbarModule = require('./navbar');
const navbar = $("nav");
const arrow_top = document.getElementById('homepage_header_container__arrow_top');

const $header_logo = $("#header_logo");

let initialTopValue;
let navbarHeight;

function calculateVpDependentVars() {
    initialTopValue = $header_logo.css('top');
    navbarHeight = $(navbar).outerHeight();
    if (initialTopValue) {
        initialTopValue = initialTopValue.substring(0, initialTopValue.length - 2);
    }
}

calculateVpDependentVars();
window.addEventListener('resize', calculateVpDependentVars);

let lastScrollPosition;

const yScrollAwayTrigger = 100;



let yScrollTriggerLogoMinify;

let media = window.matchMedia("screen and (min-width: 992px)");
let mediaXXL = window.matchMedia("screen and (min-width: 1400px)");

if(mediaXXL.matches){
    yScrollTriggerLogoMinify = 240;
}
else{
    yScrollTriggerLogoMinify = 150;
}

window.addEventListener("resize", function () {
    media = window.matchMedia("screen and (min-width: 992px)");
    mediaXXL = window.matchMedia("screen and (min-width: 1200px)");

    if(mediaXXL.matches){
        yScrollTriggerLogoMinify = 240;
    }
    else{
        yScrollTriggerLogoMinify = 150;
    }
});



/**
 * Collection of function calls on scroll events.
 */
window.addEventListener("scroll", function (event) {
    if (media.matches) {
        let yScroll = window.scrollY;
        let yScrollPercentage = (yScroll / document.body.offsetHeight) * 100;


        toggleNavbarBorder(yScroll);

        positionTopArrowAndLogo(yScroll, yScrollPercentage);

        // if ($header_logo.length) {
        //     positionHeaderLogo(yScroll, yScrollPercentage);
        // }

        //toggleNavbarVisibility(yScroll, yScrollPercentage);

        lastScrollPosition = yScroll;
    }
});


/**
 * Removes red line underneath the navbar when the scroll position isnt equaling zero
 * @param yScroll
 */
function toggleNavbarBorder(yScroll) {
    if (yScroll > yScrollTriggerLogoMinify) {
        document.getElementById('navbar_bordered').classList.remove('bordered');
    } else {
        document.getElementById('navbar_bordered').classList.add('bordered');
    }
}

/**
 * Remove navbar and header logo when scrolling downwards
 */



function toggleNavbarVisibility(yScroll, yScrollPercentage) {
    if (lastScrollPosition) {
        if (lastScrollPosition > yScroll) {
            // upscroll code
            navbar.fadeIn(250);
            if (!navbarModule.getDisableLogo()) {
                $header_logo.fadeIn(250);
            }

        } else if (yScroll > 200) {
            // downscroll code
            navbar.fadeOut(500);
            $header_logo.fadeOut(500);
        }

    }
}

function positionTopArrowAndLogo(yScroll, yScrollPercentage) {
    // arrow_top.style.top = yScrollPercentage;


    if (yScroll < yScrollAwayTrigger) {
        // follow the normal scroll speed by pretending the arrow to stick below the navbar
        $(arrow_top).css({
            'top': navbarHeight,
        });

        // when top is left empty the initial css property will be the chosen value
        $header_logo.css({
            'top': '',
        });

        // $header_logo.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
        //     function (event) {
        //         $(this).css({
        //             'transition': 'none'
        //         });
        //     });

    } else if (yScroll >= yScrollAwayTrigger) {
        // if Trigger scroll Position is exceeded the arrow should scroll to the top
        $(arrow_top).css({
            'top': yScrollAwayTrigger + navbarHeight - yScroll
        });

        if (yScroll < yScrollTriggerLogoMinify) {
            if (lastScrollPosition > yScroll && lastScrollPosition >= yScrollTriggerLogoMinify) {
                // upwards scrolling from minification. Should be triggered only once
                // let xxl = window.matchMedia("(min-width: 1500px)");
                // // differenzation due to the top value
                // if(xxl.matches){
                //     $header_logo.css(
                //         {
                //             'top': '21vh',
                //             'width': '14vw',
                //             'left': 'calc(50% - 7vw)',
                //             'z-index': '10'
                //         });
                // }
                // else {
                //     $header_logo.css(
                //         {
                //             'top': '17vh',
                //             'width': '14vw',
                //             'left': 'calc(50% - 7vw)',
                //             'z-index': '10'
                //         });
                // }

                $header_logo.css(
                    {
                        'width': '14vw',
                        'left': 'calc(50% - 7vw)',
                        'z-index': '10'
                    });
            }

            // when between both positions the logo should follow the arrow
            $header_logo.css({
                'top': initialTopValue - yScroll + yScrollAwayTrigger
            });

            // when logo has finished its animation the transition time should be removed
            $header_logo.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                function (event) {
                    $(this).css({
                        'transition': 'none'
                    });
                });
        } else {
            // when yScroll is > the minification threshold the logo should minify
            $header_logo.css(
                {
                    'transition': 'transform .5s ease-in-out, width .5s ease-in-out, top .5s ease-in-out, left .5s ease-in-out',
                    'width': '70px',
                    'left': 'calc(50% - 35px)',
                    'z-index': '15',
                    'top': '20px'
                });
        }
    }
//     {
//         if (lastScrollPosition < yScrollTrigger) {
//             // downwards scrolling
//             $(arrow_top).css({
//                 'top': yScrollTrigger + navbarHeight - yScroll
//             });
//             $header_logo.css({
//                 'top': initialTopValue - yScroll + yScrollTrigger
//             });
//         } else if (lastScrollPosition > yScrollTriggerLogoMinify) {
//             // upwards scrolling
//             $header_logo.css(
//                 {
//                     'top': initialTopValue - yScroll + yScrollTrigger,
//                     'width': '16vw',
//                     'left': 'calc(50% - 8vw)',
//                     'z-index': '10'
//                 });
//         }
//     }
// else
//     {
//         $header_logo.css(
//             {
//                 'transition': 'transform .5s ease-in-out, width .5s ease-in-out, top .5s ease-in-out, left .5s ease-in-out',
//                 'width': '70px',
//                 'left': 'calc(50% - 35px)',
//                 'z-index': '15',
//                 'top': '20px'
//             });
//     }
}

/**
 *
 * @param yScroll
 * @param yScrollPercentage
 */
function positionHeaderLogo(yScroll, yScrollPercentage) {
    if (yScroll === 0) {
        // header_logo.removeAttr('style');
        // Use CSS top and manipulate it.
        //document.querySelector('div.title-image-container').classList.remove('minified');
    } else if (yScroll < 100) {
        //document.querySelector('div.title-image-container').classList.add('minified');

        let newTopValue = initialTopValue - yScroll;

        let fromBottom = lastScrollPosition > 1;

        if (fromBottom) {
            // upwards

            $header_logo.css(
                {
                    'top': '16vh',
                    'width': '16vw',
                    'left': 'calc(50% - 8vw)',
                    'z-index': '10'
                });

        } else {
            // downwards
            $header_logo.css('transition', 'none');
            // $header_logo.css('top', newTopValue);
        }
    } else {
        // Scroll Percentage > 1.5%
        $header_logo.css(
            {
                'transition': 'transform .5s ease-in-out, width .5s ease-in-out, top .5s ease-in-out, left .5s ease-in-out',
                'width': '70px',
                'left': 'calc(50% - 35px)',
                'z-index': '15',
                'top': '20px'
            });
    }
}